<template>
  <div class="block-folder-links">
    <SlotLink
      v-for="link of response"
      :key="link.real_path || link.sb_slug"
      class="block-folder-links__item"
      :url="`..${link.real_path ? link.real_path : `/${link.sb_slug}`}`"
    >
      <div class="folder-links-item__title">
        {{ link.name }}
      </div>
      <div class="folder-links-item__more">
        {{ useTranslation('general', 'learn_more') }}
      </div>
    </SlotLink>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

/*
  Get topiclinks from strapi
*/
const subtopic = computed(() => props.data?.subtopic);
const { find } = useStrapi4();
const { data: response } = useLazyAsyncData(
    `topiclinks/${getUid()}`,
    () => find(subtopic.value, {
        filters: {
            $or: [
                {
                    is_hidden: {
                        $eq: false,
                    },
                },
                {
                    is_hidden: {
                        $null: true,
                    },
                },
            ],
        },
        fields: ['name', 'sb_slug'],
        sort: {
            name: 'ASC',
        },
        pagination: {
            limit: -1,
        },
    }),
    {
        transform: (res) => {
            const mapped = res.data.map((entry) => {
                const result = entry.attributes;
                return result;
            });

            return mapped;
        },
        watch: [subtopic],
    },
);
</script>

<style lang="scss" scoped>
.block-folder-links {
    @include component-spacing(30px, 60px);
    @include grid-columns(2, 16);
    @include grid-layout(16);
    @include fluid('grid-gap', 10px, 30px);
    @include fluid('margin-bottom', 26px, 120px);
    filter: drop-shadow(30px 30px 60px rgba(0, 62, 48, 0.1));

    @include tablet {
        @include grid-layout(2);
        @include grid-columns(1, var(--grid-columns));
    }

    @include mobile {
        @include grid-layout(var(--grid-columns));
    }

}

.block-folder-links__item {
    @include typo-size('a');
    padding: 20px 30px 26px 30px;
    border-radius: 12px;
    background: $C_WHITE;
    grid-column-end: span 4;
    transition: transform 0.25s ease-in-out;

    @include tablet {
        grid-column-end: span 1;
    }

    @include mobile {
        grid-column-end: span var(--grid-columns);
    }

    &:hover {
        transform: scale(1.015);
    }
}

.folder-links-item__title {
    @include typo-font('bold');
    margin-bottom: 7px;
}

.folder-links-item__more {
    @include typo-font('italic');
    color: $C_PRIMARY;
}
</style>
